export default {
  requestsInProgress: 0,
  charts: [],
  report: [],
  areas: {
    selected: [],
    excluded: [],
  },
  sectionsToggle: {
    filters: true,
    performance: true,
    interactions: true,
    details: true,
  },
};
